var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intellectual-btn +mask-one"},[_c('span',{staticClass:"intellectual-btn.mas"},[_vm._v(_vm._s(_vm.btnText.subText=="面议"?_vm.btnText.subText:('￥'+_vm.btnText.subText)))])])}
var staticRenderFns = []

export { render, staticRenderFns }